+
(function lawBookControllerDefinition() {
    'use strict';

    angular.module('LawBook')
        .controller('LawBookAddController', [
            '$scope', 'config', '$state', 'errorsExtend', 'documentService', 'documentTypeService', 'auth', 'authExtend', 'storageService', 'fileService', 'organizationalUnitService', '$filter',
            function lawBookAddController($scope, config, $state, errors, documentService, documentTypeService, auth, authExtend, storageService, fileService, organizationalUnitService, $filter) {
                $scope.loading = true;
                $scope.loadDocumentType = function () {
                    documentTypeService.getBySystemName($scope.lawBookSystemName, 'Detail', 'LAWBOOK WRITE').then(function (result) {
                        if (result) {
                            $scope.document.documentTypes.push({
                                documentTypeId: result.id,
                                documentTypeName: result.name,
                                metadatas: []
                            });

                            $scope.loadMetadatas(result.metadata);
                            $scope.loading = false;
                        }
                    }, function (error) {
                        $scope.loading = false;
                        errors.showError(error);
                        $scope.loading = false;
                    });
                };

                $scope.loadMetadatas = function (metadatas) {
                    metadatas.forEach(function (metadata) {
                        if (metadata.isEnabled) {
                            $scope.document.documentTypes[0].metadatas.push({
                                idObject: $scope.document.documentTypes[0].documentTypeId + '' + metadata.metadataId,
                                metadataId: metadata.metadataId,
                                metadataIsRequired: metadata.isRequired,
                                metadataIsUnique: metadata.isUnique,
                                metadataEnabled: true,
                                metadataValue: $scope.getMetadataValue(metadata),
                                metadataType: metadata.metadataType,
                                metadataSystemName: metadata.metadataSystemName,
                                metadataLabel: metadata.metadataLabel,
                                metadataOptions: metadata.optionValues,
                                maskOptions: metadata.maskOptions,
                                metadataAsName: metadata.asName,
                                metadataIsMultivalue: metadata.isMultivalue,
                                metadataIsAutoComplete: metadata.metadataSystemName === '_estadoLLS' || metadata.metadataSystemName === '_tnomina'
                            });
                        }
                    });
                };

                $scope.getMetadataValue = function (metadata) {
                    if ((metadata.metadataType === 'comboKV' || metadata.metadataType === 'combo') && metadata.optionValues) {
                        var options = JSON.parse(metadata.optionValues);
                        if (options.length === 1 || metadata.metadataSystemName === $scope.estadoSystemName) {
                            return options[0].value;
                        }
                    }

                    return '';
                };

                $scope.addSignedFile = function () {
                    $scope.files.requireSignatureSelection.forEach(function (file) {
                        if (file && file.size && file.name && file.name.toLowerCase().indexOf(".pdf") > 0) {
                            file.fsize = fileService.FormatfileSize(file.size);
                            var index = $scope.getIndexFile(file, $scope.files.requireSignatureList);
                            if (~index) {
                                $scope.files.requireSignatureList[index] = file;
                            } else {
                                var indexAux = $scope.getIndexFile(file, $scope.files.attachedList);
                                if (indexAux === -1) {
                                    $scope.files.requireSignatureList.push(file);
                                } else {
                                    errors.showError('AddSignedFileError');
                                }
                            }

                            $scope.files.requireSignatureListOpen = true;
                        }
                    });

                    $scope.files.requireSignatureSelection = [];
                };

                $scope.removeSignedFile = function (file) {
                    var index = $scope.getIndexFile(file, $scope.files.requireSignatureList);

                    if (~index) {
                        if ($scope.preview.index === index) {
                            $scope.hidePreview();
                        }

                        $scope.files.requireSignatureList.splice(index, 1);
                    }
                }

                $scope.addAttachedFile = function () {
                    $scope.files.attachedSelection.forEach(function (file) {
                        if (file && file.size) {
                            file.fsize = fileService.FormatfileSize(file.size);
                            var index = $scope.getIndexFile(file, $scope.files.attachedList);
                            if (~index) {
                                $scope.files.attachedList[index] = file;
                            } else {
                                var indexAux = $scope.getIndexFile(file, $scope.files.requireSignatureList);
                                if (indexAux === -1) {
                                    $scope.files.attachedList.push(file);
                                } else {
                                    errors.showError('AddAttachedFileError');
                                }
                            }

                            $scope.files.attachedListOpen = true;
                        }
                    });

                    $scope.files.attachedSelection = [];
                };

                $scope.removeAttachedFile = function (file) {
                    var index = $scope.getIndexFile(file, $scope.files.attachedList);

                    if (~index) {
                        if ($scope.preview.index === index) {
                            $scope.hidePreview();
                        }

                        $scope.files.attachedList.splice(index, 1);
                    }
                };

                $scope.getIndexFile = function (fileNew, collection) {
                    for (var i in collection) {
                        if (collection.hasOwnProperty(i)) {
                            var fileOld = collection[i];

                            if (fileOld.name === fileNew.name) {
                                return i;
                            }
                        }
                    };

                    return -1;
                };

                $scope.previewFile = function (item, index) {
                    $scope.preview.content = null;
                    $scope.preview.loading = true;
                    $scope.preview.closed = false;
                    $scope.preview.invalid = false;
                    $scope.files.requireSignatureListOpen = false;
                    $scope.files.attachedListOpen = false;

                    fileService.preview(item, true).then(function (result) {

                        $scope.preview.content = result;

                        $scope.preview.item = item;
                        $scope.preview.index = index;
                        $scope.preview.loading = false;
                    }, function (error) {
                        if (error.data && error.data.modelState && error.data.modelState.no_converter) {
                            $scope.preview.loading = false;
                            $scope.preview.invalid = true;
                            $scope.preview.item = item;
                            $scope.preview.index = index;
                        } else {
                            errors.showError(error);
                            $scope.hidePreview();
                        }
                    });

                };

                $scope.hidePreview = function () {

                    $scope.preview = {
                        closed: true,
                        loading: false,
                        content: null,
                        index: null,
                        invalid: false,
                        item: null
                    };

                    $scope.files.requireSignatureListOpen = true;
                    $scope.files.attachedListOpen = true;
                };

                $scope.nextPreview = function () {
                    if ($scope.preview.item && $scope.preview.index != null) {
                        if (!$scope.preview.item.maxSigners || $scope.preview.item.maxSigners === 0) {
                            if ($scope.preview.index + 1 < $scope.files.attachedList.length) {
                                $scope.preview.index++;
                                $scope.previewFile($scope.files.attachedList[$scope.preview.index], $scope.preview.index);
                            }
                        } else {
                            if ($scope.preview.index + 1 < $scope.files.requireSignatureList.length) {
                                $scope.preview.index++;
                                $scope.previewFile($scope.files.requireSignatureList[$scope.preview.index], $scope.preview.index);
                            } else {
                                $scope.preview.index = 0;
                                $scope.previewFile($scope.files.attachedList[$scope.preview.index], $scope.preview.index);
                            }
                        }
                    }
                };

                $scope.prevPreview = function () {
                    if ($scope.preview.item && $scope.preview.index != null) {
                        if ($scope.preview.item.maxSigners > 0) {
                            if ($scope.preview.index >= 0 && $scope.preview.index < $scope.files.requireSignatureList.length) {
                                $scope.preview.index--;
                                $scope.previewFile($scope.files.requireSignatureList[$scope.preview.index], $scope.preview.index);
                            }
                        } else {
                            if ($scope.preview.index == 0) {
                                $scope.preview.index = $scope.files.requireSignatureList.length - 1;
                                $scope.previewFile($scope.files.requireSignatureList[$scope.preview.index], $scope.preview.index);
                            } else {
                                $scope.preview.index--;
                                $scope.previewFile($scope.files.attachedList[$scope.preview.index], $scope.preview.index);
                            }
                        }
                    }
                };

                $scope.nextDisabled = function () {
                    if ($scope.preview.item && $scope.preview.index != null) {
                        if (($scope.preview.item.maxSigners || $scope.preview.item.maxSigners === 0) && $scope.preview.index == $scope.files.attachedList.length - 1) {
                            return true;
                        } else if ($scope.files.requireSignatureList.length > 0 &&
                            $scope.files.attachedList.length == 0 && $scope.preview.index == $scope.files.requireSignatureList.length - 1) {
                            return true;
                        }
                    }

                    return false;
                }

                $scope.prevDisabled = function () {
                    if ($scope.preview.item && $scope.preview.index != null) {
                        if ($scope.preview.item.maxSigners > 0 && $scope.preview.index == 0) {
                            return true;
                        } else if ($scope.files.requireSignatureList.length == 0 &&
                            $scope.files.attachedList.length > 0 && $scope.preview.index == 0) {
                            return true;
                        }
                    }

                    return false;
                }

                $scope.metadataCount = function () {
                    return $scope.document.documentTypes[0].metadatas.length;
                }

                $scope.cancel = function () {
                    $state.go('lawbook-find');
                }

                $scope.save = function () {
                    if ($scope.loading)
                        return;

                    var metadatas = $scope.document.documentTypes[0].metadatas;
                    for (var i = 0; i < metadatas.length; i++) {
                        if (metadatas[i].metadataSystemName === '_peri' && metadatas[i].metadataValue) {
                            var year = metadatas[i].metadataValue.substring(0, 4);
                            var month = metadatas[i].metadataValue.substring(4);

                            if (year < 1900 || month < 1 || month > 12) {
                                errors.showError('VerifyPeriodFormat');
                                return;
                            }
                        }
                    }

                    if (!$scope.documentForm.$valid) {
                        $scope.documentForm.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return;
                    }

                    if ($scope.document.organizationalUnit && $scope.document.organizationalUnit.id) {
                        $scope.document.organizationalUnitId = $scope.document.organizationalUnit.id;
                    }

                    return organizationalUnitService.getConfigByName($scope.document.organizationalUnitId, '#OuConfigSectionLawbook').then(function (result) {

                        if (result && result.metatadataValues.length > 0) {
                            var config = {};
                            result.metatadataValues.forEach(function (item) {
                                if (item.name == '#CoordinateLawbookUp') {
                                    config.up = item.value;
                                }
                                if (item.name == '#CoordinateLawbookBottom') {
                                    config.bottom = item.value;
                                }
                                if (item.name == '#CoordinateLawbookLeft') {
                                    config.left = item.value;
                                }
                                if (item.name == '#CoordinateLawbookRight') {
                                    config.right = item.value;
                                }
                            });

                            if (angular.isUndefined(config.up) || angular.isUndefined(config.bottom) || angular.isUndefined(config.left) || angular.isUndefined(config.right)) {
                                errors.showError('LawBookConfigNotDefinedError');
                                return false;
                            }

                            $scope.document.singData = {};

                            $scope.files.requireSignatureList.forEach(function (file) {
                                $scope.document.singData[file.name] = 1;
                            });

                            var files = $scope.files.requireSignatureList.concat($scope.files.attachedList);
                            $scope.loading = true;
                            return documentService.createAndCheckin($scope.document, files).then(function (result) {
                                var filter = storageService.getMyDocumentFilter();
                                filter.name = '';

                                storageService.setMyDocumentFilter(filter);
                                if (result.data && result.data.singData &&
                                    Object.keys(result.data.singData).length === $scope.files.requireSignatureList.length && $scope.files.requireSignatureList.length > 0) {
                                    documentService.checkout(result.data).then(function (documentCheckedOut) {
                                        var metadataEstado = $filter('filter')(documentCheckedOut.documentTypes[0].metadatas, { systemName: '_estadoLLS' }, true);
                                        metadataEstado[0].metadataValue = '03';
                                        documentService.modifyAndCheckin(documentCheckedOut, documentCheckedOut.files).then(function () {
                                            $scope.loading = false;
                                            $state.go('lawbook-find');
                                        }, function (error) {
                                            $scope.loading = false;
                                            errors.showError(error);
                                        });
                                    }, function (error) {
                                        $scope.loading = false;
                                        errors.showError(error);
                                    });
                                } else {
                                    $scope.loading = false;
                                    $state.go('lawbook-find');
                                }
                            }, function (error) {
                                $scope.loading = false;
                                errors.showError(error);
                            });
                        } else {
                            errors.showError('LawBookConfigNotDefinedError');
                        }
                    }, function (error) {
                        if (error.status === 404) {
                            errors.showError('LawBookConfigNotDefinedError');
                        } else {
                            errors.showError(error);
                        }
                    });

                };

                $scope.load = function () {
                    $scope.lawBookSystemName = '_ley';
                    $scope.estadoSystemName = '_estadoLLS';

                    $scope.document = {
                        name: '',
                        documentTypes: [],
                        categories: [],
                        containers: [],
                        organizationalUnitId: auth.getOrganizationId(),
                        isDocumentPerFile: false
                    };

                    $scope.files = {
                        requireSignatureSelection: [],
                        requireSignatureList: [],
                        requireSignatureListOpen: false,
                        attachedSelection: [],
                        attachedList: [],
                        attachedListOpen: false
                    };

                    $scope.preview = {
                        closed: true,
                        loading: false,
                        content: null,
                        index: null,
                        item: null,
                        invalid: false
                    };

                    organizationalUnitService.getOuTReeControl().then(function (result) {
                        $scope.organizationalUnits = result;
                        $scope.document.organizationalUnit = $scope.organizationalUnits[0];
                    }, function (error) {
                        errors.showError(error);
                    });
                    $scope.loadDocumentType();
                };

                $scope.load();
            }
        ]);
})();